import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import BaseLayout from 'ff/debrief/layouts/BaseLayout';
import Header from 'ff/debrief/components/Header';
import TwoDeeMap from 'ff/debrief/components/map/Map';
import ModalManager from 'ff/debrief/modalManager';
import { useMapSettings } from 'ff/debrief/hooks';
import { LinkToDebrief, LinkToHome, RouteContext } from 'ff/debrief/router';
import { RouteContextType } from 'ff/debrief/router/RouteContext';
import useDebug from 'ff/common/debugMode/useDebug';
import { DebugControls } from 'ff/debrief/components/DebugControls';

const LazyThreeDeeMap = lazy(
    () => import('ff/debrief/components/map/3d/3DMap')
);
function ThreeDeeMap(props: React.PropsWithChildren<{}>) {
    return (
        <Suspense>
            <LazyThreeDeeMap>{props.children}</LazyThreeDeeMap>
        </Suspense>
    );
}

const MapGridLayout = () => {
    const { mapMode } = useMapSettings();
    const { isDebugMode } = useDebug();
    const Map = mapMode === '3D' ? ThreeDeeMap : TwoDeeMap;

    const [routeContextValue, setRouteContextValue] =
        React.useState<RouteContextType>({
            returnLink: LinkToHome,
            debriefLink: LinkToDebrief,
            page: 'TrackListView',
        });

    return (
        <RouteContext.Provider value={routeContextValue}>
            <BaseLayout>
                <Header>{isDebugMode && <DebugControls />}</Header>
                <Map>
                    <Outlet
                        context={{ setRouteContext: setRouteContextValue }}
                    />
                </Map>
                <ModalManager />
            </BaseLayout>
        </RouteContext.Provider>
    );
};

export default MapGridLayout;
